import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { AuthenticationContext } from "@sdk-react-identity/core";
import { StoreContextProvider } from "@sdk-react-storage/core";
import { memoryStore } from "@sdk-react-storage/memory";
import { createDSVTheme } from "@sdk-react-ui-atoms/theme";
import App from "./App";
import { authProvider } from "./helpers/authProvider";
import { Provider } from "react-redux";
import { store } from "./redux/store";

// ✅ Kendo styles only — no manual license registration here
import "@progress/kendo-theme-default/dist/all.css";
import "./sitecss.css";

// Load setup files from features folders
import.meta.glob("./features/*/setup.ts", { eager: true });
import.meta.glob("../features/*/setup.ts", { eager: true });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLDivElement
);

const contextstore = memoryStore();
const DSVTheme = createDSVTheme();

const Main = () => {
  return (
    <StrictMode>
      <AuthenticationContext.Provider value={authProvider}>
        <Provider store={store}>
          <StoreContextProvider value={contextstore}>
            <ThemeProvider defaultMode="light" theme={DSVTheme}>
              <CssBaseline />
              <App />
            </ThemeProvider>
          </StoreContextProvider>
        </Provider>
      </AuthenticationContext.Provider>
    </StrictMode>
  );
};

root.render(<Main />);
